import { render, staticRenderFns } from "./ventaAdd.vue?vue&type=template&id=f8351016"
import script from "./ventaAdd.vue?vue&type=script&lang=js"
export * from "./ventaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports